import { ArrowRight, Check } from "@phosphor-icons/react";

export function Audience() {
	return (
		<section className="py-16 px-4 bg-white">
			<div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
				{/* For Customers */}
				<div className="relative rounded-[20px] overflow-hidden bg-[#EEF2FF] min-h-[420px] flex flex-col">
					{/* Illustration — top right, fades in */}
					<div
						className="absolute top-0 right-0 w-[65%] h-[55%] pointer-events-none"
						style={{
							maskImage:
								"radial-gradient(ellipse at top right, black 30%, transparent 75%)",
						}}
					>
						<img
							src="/illustrations/for-customers.png"
							alt=""
							aria-hidden="true"
							className="w-full h-full object-cover object-left-bottom"
							style={{ mixBlendMode: "multiply" }}
						/>
					</div>

					{/* Content */}
					<div className="relative z-10 flex flex-col h-full p-8 pt-10">
						{/* Label pill */}
						<span className="self-start text-xs font-bold uppercase tracking-widest text-primary bg-primary/10 px-3 py-1 rounded-full mb-auto">
							For Customers
						</span>

						{/* Push content to bottom */}
						<div className="mt-auto pt-32">
							<h2 className="text-3xl font-extrabold text-[#0F172A] mb-3 leading-tight">
								Your time,
								<br />
								back in your hands.
							</h2>
							<p className="text-[15px] text-[#475569] leading-relaxed mb-6 max-w-xs">
								Post the errand, review the bids, and pick the runner you trust.
								Your money stays locked in escrow until the job is done.
							</p>

							<ul className="space-y-2 mb-7">
								{[
									"Reclaim hours every week",
									"Negotiate your own price",
									"Escrow-protected payments",
								].map((f) => (
									<li
										key={f}
										className="flex items-center gap-2 text-sm font-medium text-[#0F172A]"
									>
										<Check
											size={16}
											weight="bold"
											className="text-primary flex-shrink-0"
										/>
										{f}
									</li>
								))}
							</ul>

							<button
								type="button"
								data-tally-open="Bza1xR"
								data-tally-layout="modal"
								data-tally-width="700"
								data-tally-emoji-text="👋"
								data-tally-emoji-animation="wave"
								data-role="customer"
								className="inline-flex items-center gap-2 text-sm font-bold text-primary hover:gap-3 transition-all"
							>
								Post an Errand <ArrowRight weight="bold" size={16} />
							</button>
						</div>
					</div>
				</div>

				{/* For Runners */}
				<div className="relative rounded-[20px] overflow-hidden bg-[#E6FBF5] min-h-[420px] flex flex-col">
					{/* Illustration — top right, fades in */}
					<div
						className="absolute top-0 right-0 w-[70%] h-[55%] pointer-events-none"
						style={{
							maskImage:
								"radial-gradient(ellipse at top right, black 30%, transparent 75%)",
						}}
					>
						<img
							src="/illustrations/for-runners.png"
							alt=""
							aria-hidden="true"
							className="w-full h-full object-cover object-left-bottom"
							style={{ mixBlendMode: "multiply" }}
						/>
					</div>

					{/* Content */}
					<div className="relative z-10 flex flex-col h-full p-8 pt-10">
						{/* Label pill */}
						<span className="self-start text-xs font-bold uppercase tracking-widest text-secondary bg-secondary/10 px-3 py-1 rounded-full mb-auto">
							For Runners
						</span>

						{/* Push content to bottom */}
						<div className="mt-auto pt-32">
							<h2 className="text-3xl font-extrabold text-[#0F172A] mb-3 leading-tight">
								Earn on your
								<br />
								own terms.
							</h2>
							<p className="text-[15px] text-[#475569] leading-relaxed mb-6 max-w-xs">
								Accept the errands you want, set your own pace, and climb from
								Bronze to Platinum for better rates and priority jobs.
							</p>

							<ul className="space-y-2 mb-7">
								{[
									"Upfront, transparent earnings",
									"Jobs near you",
									"Tiered bonuses as you level up",
								].map((f) => (
									<li
										key={f}
										className="flex items-center gap-2 text-sm font-medium text-[#0F172A]"
									>
										<Check
											size={16}
											weight="bold"
											className="text-secondary flex-shrink-0"
										/>
										{f}
									</li>
								))}
							</ul>

							<button
								type="button"
								data-tally-open="Bza1xR"
								data-tally-layout="modal"
								data-tally-width="700"
								data-tally-emoji-text="👋"
								data-tally-emoji-animation="wave"
								data-role="runner"
								className="inline-flex items-center gap-2 text-sm font-bold text-secondary hover:gap-3 transition-all"
							>
								Apply to be a Runner <ArrowRight weight="bold" size={16} />
							</button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
